import {
    update,
    recodeNow
} from "../../../../../components/indexDB/indexDBStora";

import { CurrentTime } from "../../../../current";
import { v4 as uuid } from "uuid";

export const consumeInventory = async (
    batches = [],
    meta = {}
) => {

    if (!Array.isArray(batches) || batches.length === 0) {
        return {
            success: false,
            message: "No batches found",
            data: []
        };
    }

    try {

        const currentTime = CurrentTime(true, true);
        const processedBatches = [];

        for (const batch of batches) {

            await update("batches", {
                ...batch,
                currentQty: batch.summary.remainingQty
            });

            await recodeNow({
                id: uuid(),
                productId: batch.productId,
                batchId: batch.id,
                createdAt: currentTime,
                qty: batch.summary.deductedQty,
                transactionType: "OUT",
                unit: meta.measure === "weight" ? "g" : "piece",
                taker: meta.taker,
                invoiceId: meta.invoiceId || ""
            }, "transactionBatch");

            processedBatches.push(batch.summary);
        }

        return {
            success: true,
            message: "Inventory updated successfully",
            data: processedBatches
        };

    }
    catch (err) {

        return {
            success: false,
            message: err.message || "Unknown error",
            data: []
        };

    }

};